import { GatsbyProductsPage } from 'src/features/products'

export default GatsbyProductsPage
